import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import propertyReducer, { MULTI_SELECT_STORAGE_KEY } from "./slices/property";

export const store = configureStore({
  reducer: {
    property: propertyReducer,
  },
});

// Mirror the multi-select property state to sessionStorage on every change so
// it survives a page reload within the same tab (see property.ts for why).
let lastPropertyState: ReturnType<typeof store.getState>["property"] | null =
  null;
let lastPersisted: string | null = null;
store.subscribe(() => {
  const propertyState = store.getState().property;
  // Reducers return the same reference when nothing changed (e.g. a dispatch
  // this slice doesn't handle) — skip the serialization work entirely then,
  // rather than only skipping the sessionStorage write after doing it anyway.
  if (propertyState === lastPropertyState) return;
  lastPropertyState = propertyState;

  const { selectedMultiProperties, hasAutoSelectedPortfolio } = propertyState;
  const serialized = JSON.stringify({
    selectedMultiProperties,
    hasAutoSelectedPortfolio,
  });
  if (serialized === lastPersisted) return;
  lastPersisted = serialized;
  try {
    sessionStorage.setItem(MULTI_SELECT_STORAGE_KEY, serialized);
  } catch {
    // sessionStorage unavailable (e.g. private browsing quota) — degrade to in-memory only.
  }
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
